import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoCantidadComprobanteTipoComprobante(props) {

    var options = {
        series: props.series,
        chart: {
            height: 350,
            type: 'line',
            stacked: false,
            zoom: {
                enabled: false
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return global.decimalFormat(val.toFixed(2))
            }
        },
        stroke: {
            width: [1, 1, 4]
        },
        title: {
            text: 'Establecimiento - Cantidad Comprobantes',
            align: 'center',
            style: {
                fontSize: '18px',
                fontWeight: 'bold',
                fontFamily: undefined,
                color: '#263238'
            }
        },
        xaxis: {
            categories: props.establecimientos,
        },
        yaxis: [
            {
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: '#008FFB'
                },
                labels: {
                    style: {
                        colors: '#008FFB',
                    },
                    formatter: function (val) {
                        return global.decimalFormat(val.toFixed(2))
                    }
                },
                tooltip: {
                    enabled: true
                }
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: '#00E396'
                },
                labels: {
                    style: {
                        colors: '#00E396',
                    },
                    formatter: function (val) {
                        return global.decimalFormat(val.toFixed(2))
                    }
                }
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: '#FEB019'
                },
                labels: {
                    style: {
                        colors: '#FEB019',
                    },
                    formatter: function (val) {
                        return global.decimalFormat(val.toFixed(2))
                    }
                }
            },
            {
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: '#ea4335'
                },
                labels: {
                    style: {
                        colors: '#ea4335',
                    },
                    formatter: function (val) {
                        return global.decimalFormat(val.toFixed(2))
                    }
                }
            }
        ],
        tooltip: {
            fixed: {
                enabled: true,
                position: 'topLeft',
                offsetY: 30,
                offsetX: 60
            },
        },
        legend: {
            horizontalAlign: 'left',
            offsetX: 40
        }
    };

    return (
        <div id="chart">
            <Chart options={options} series={options.series} width="100%" height="500px" />
        </div>
    );
}